import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { DissolvedOxygenSensorNodeModel } from './DissolvedOxygenSensorNodeModel';
import { DissolvedOxygenSensorNodeWidget } from './DissolvedOxygenSensorNodeWidget';

export class DissolvedOxygenSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.DissolvedOxygenSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new DissolvedOxygenSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <DissolvedOxygenSensorNodeWidget engine={this.engine} node={event.model} width={50} height={44} renderedOnMap />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
